import { useMemo, useState, useEffect } from 'react';

export type UrlParams = {
  type?: string;
  from?: string;
  to?: string;
  adults?: string;
  children?: string;
  infants?: string;
  buyPath?: string;
  fdp?: string;
  bd?: string;
};

const parseHashUrlParams = (hash: string): UrlParams => {
  const harsToParse =
    hash.charAt(hash.length - 1) === '/' ? hash.replace(/.$/, '') : hash;
  const urlParams = harsToParse.split('/').pop() || '';
  return urlParams.split(/(;|%3B)/gi).reduce((paramsObj, params) => {
    const [key, value] = params.split('=');
    if (key && value) {
      paramsObj[key] = value;
    } else if (key === 'fdp' || key === 'bd') {
      paramsObj[key] = '';
    }
    return paramsObj;
  }, {});
};

export const useUrlParams = (hash: string | null): UrlParams => {
  return useMemo(() => {
    return !hash ? {} : parseHashUrlParams(decodeURI(hash));
  }, [hash]);
};

export const useHash = (): string => {
  const [hash, setHash] = useState(window.location.hash);
  const listenToPopstate = (): void => {
    const winPath = window.location.hash;
    setHash(winPath);
  };
  useEffect(() => {
    window.addEventListener('popstate', listenToPopstate);
    return () => {
      window.removeEventListener('popstate', listenToPopstate);
    };
  }, []);
  return hash;
};
